module.exports = "/_next/static/resources/photo-2-25cc73e0789c8bf282e065b3fd488c55.webp";